import { Controller } from "@hotwired/stimulus"
import { hideAll as hideAllPoppers } from 'tippy.js'

export default class extends Controller {
  // Only this button's own popup, so a stacked popover keeps its parent open.
  hide() {
    const instance = this.element.closest('[data-tippy-root]')?._tippy
    if (instance) {
      instance.hide()
    } else {
      hideAllPoppers()
    }
  }

  // For actions opening another surface, so nothing floats above it.
  hideAll() {
    hideAllPoppers()
  }
}
